const routerView = {
  template: "<router-view></router-view>"
};

export default [
  // 系统设置模块
  {
    path: "/system",
    component: routerView,
    children: [{
        path: "/system/user",
        component: () =>
          import("@/views/systemSetting/userContorller/UserPage.vue")
      },
      {
        path: "/system/role",
        component: () =>
          import("@/views/systemSetting/roleContorller/rolePage.vue")
      },
      {
        path: "/system/menuPage",
        component: () =>
          import("@/views/systemSetting/menuManager/NewMenuPage.vue")
      },
      {
        path: "/system/org",
        component: () =>
          import("@/views/systemSetting/orgManager/Organization.vue")
      },
      {
        path: "/system/usageAnalysis", //用户行为分析暂时不用
        component: () =>
          import("@/views/systemSetting/usageAnalysis.vue")
      },
      {
        path: "/system/org/deviceTree",
        component: () =>
          import("@/views/systemSetting/orgManager/DeviceTreeManage.vue")
      },
      {
        path: "/system/org/deviceTree/group",
        component: () =>
          import("@/views/systemSetting/orgManager/DeviceTreeManageGroup.vue")
      },
      {
        path: "/system/org/contact",
        component: () =>
          import("@/views/systemSetting/orgManager/ContactManager.vue")
      },
      {
        path: "/system/org/monitor",
        component: () =>
          import("@/views/systemSetting/orgManager/MonitorManager.vue")
      },
      {
        path: "/system/com",
        component: () =>
          import("@/views/systemSetting/companyManager/EnterpriseManager.vue")
      },
      {
        path: "/system/com/ContactManager",
        component: () =>
          import("@/views/systemSetting/companyManager/ContactManager.vue")
      },
      {
        path: "/system/com/DeviceManage",
        component: () =>
          import("@/views/systemSetting/companyManager/DeviceTreeManage.vue")
      },
    ]
  },
  // 告警管理模块
  {
    path: "/alarm",
    component: routerView,
    children: [{
        path: "/alarm/alarmList",
        component: () =>
          import("@/views/alarmManage/alarmList.vue")
      },
      {
        path: "/alarm/alarmPush",
        component: () =>
          import("@/views/alarmManage/alarmPush.vue")
      },
      {
        path: "/alarm/alarmSetting",
        component: () =>
          import("@/views/alarmManage/alarmSetting.vue")
      },
      {
        path: "/alarm/alarmList/concentrationAlarm",
        component: () =>
          import("@/views/alarmManage/concentrationAlarm.vue")
      },
      {
        path: "/alarm/alarmList/offlineAlarm",
        component: () =>
          import("@/views/alarmManage/offlineAlarm.vue")
      },
      {
        path: "/alarm/alarmList/overdueAlarm",
        component: () =>
          import("@/views/alarmManage/overdueCleanAlarm.vue")
      }
    ]
  },
  // 在线数据模块
  {
    path: "/onlineData",
    component: routerView,
    children: [{
        path: "/onlineData/lampblackConcentration",
        component: () =>
          import("@/views/onlineData/lampblackConcentration/index.vue")
      },
      {
        path: "/onlineData/electricData",
        component: () =>
          import("@/views/onlineData/electricData/index.vue")
      },
      {
        path: "/onlineData/onlineMap",
        component: () =>
          import("@/views/onlineDatas/onlineMap/index.vue")
      }
    ]
  },
  //企业监测在电模块
  {
    path: "/onlineDataCompany",
    component: routerView,
    children: [{
        path: "/onlineDataCompany/lampblackConcentration",
        component: () =>
          import("@/views/onlineDataCompany/lampblackConcentration/index.vue")
      },
      {
        path: "/onlineDataCompany/electricData",
        component: () =>
          import("@/views/onlineDataCompany/electricData/index.vue")
      }

    ]
  },
  // 审核审批模块
  {
    path: "auditApproval",
    component: routerView,
    children: [{
        path: "/auditApproval/declare",
        component: () =>
          import("@/views/auditApproval/Declare.vue")
      },
      {
        path: "/auditApproval/notice",
        component: () =>
          import("@/views/auditApproval/Notice.vue")
      }
    ]
  },
  // 数据看板模块
  {
    path: "/dashboard",
    component: routerView,
    children: [{
        path: "/dashboard/index",
        component: () =>
          import("@/views/dashboard/index.vue")
      },
      {
        path: "/dashboard/standard",
        component: () =>
          import("@/views/dashboard/standard/index.vue")
      },
      {
        path: "/dashboard/equipment",
        component: () =>
          import("@/views/dashboard/equipmentException/index.vue")
      }, {
        path: "/dashboard/index/dashboardInfo",
        component: () =>
          import("@/views/dashboardSecond/dashboardInfo.vue")
      }, {
        path: "/dashboard/index/dashboardClean",
        component: () =>
          import("@/views/dashboardSecond/dashboardClean.vue")
      }, {
        path: "/dashboard/index/dashboardNotClean",
        component: () =>
          import("@/views/dashboardSecond/dashboardNotClean.vue")
      }
    ]
  },
  // 净化清洗情况
  {
    path: "/clean",
    component: routerView,
    children: [{
        path: "/clean/PurifierInfo",
        component: () =>
          import("@/views/clean/PurifierInfo.vue")
      },
      {
        path: "/clean/CleanInfo",
        component: () =>
          import("@/views/clean/CleanInfo.vue")
      },
      {
        path: '/clean/CleanInfo/details',
        component: () =>
          import("@/views/clean/Details.vue")
      }
    ]
  },
  // 数据分析模块
  {
    path: "/dataAnalysis",
    component: routerView,
    children: [{
      path: "/dataAnalysis/AnalysisList",
      component: () =>
        import("@/views/dataAnalysis/AnalysisAreaIndustry.vue")
    }, {
      path: "/dataAnalysis/AnalysisChildrenA",
      component: () =>
        import("@/views/dataAnalysis/children/abnormalEnterprise.vue")
    }, {
      path: "/dataAnalysis/AnalysisChildrenB",
      component: () =>
        import("@/views/dataAnalysis/children/abnormalEnterpriseBad.vue")
    }, {
      path: "/dataAnalysis/AnalysisChildrenC",
      component: () =>
        import("@/views/dataAnalysis/children/abnormalEnterpriseClean.vue")
    }, {
      path: "/dataAnalysis/AnalysisChildrenD",
      component: () =>
        import("@/views/dataAnalysis/children/abnormalEnterpriseDevice.vue")
    }, {
      path: "/dataAnalysis/AnalysisChildrenE",
      component: () =>
        import("@/views/dataAnalysis/children/abnormalEnterpriseOill.vue")
    }, {
      path: "/dataAnalysis/statisticReport",
      component: () =>
        import("@/views/dataAnalysis/StatisticReport.vue")
    }, {
      path: "/dataAnalysis/checkReport",
      component: () =>
        import("@/views/dataAnalysis/checkReport.vue")
    }]
  },
  // 企业端-清洗管理
  {
    path: "/cleanManage",
    component: routerView,
    children: [{
      path: "/cleanManage/CleanCycle",
      component: () =>
        import("@/views/en_cleanManage/cleanPeriod.vue")
    }]
  },
  // 异常申报模块
  {
    path: "/submit",
    component: routerView,
    children: [{
        path: "/submit/submitList",
        component: () =>
          import("@/views/unusualSubmit/submitList.vue")
      },
      {
        path: "/submit/submitTable",
        component: () =>
          import("@/views/unusualSubmit/submitTable.vue")
	  },
	  {
        path: "/submit/submitList/concentrationAlarm",
        component: () =>
          import("@/views/alarmManage/concentrationAlarm.vue")
      },
      {
        path: "/submit/submitList/offlineAlarm",
        component: () =>
          import("@/views/alarmManage/offlineAlarm.vue")
      },
      {
        path: "/submit/submitList/overdueAlarm",
        component: () =>
          import("@/views/alarmManage/overdueCleanAlarm.vue")
      }
    ]
  },
  // 工作通知模块
  {
    path: "/notice",
    component: routerView,
    children: [{
        path: "/notice/cleanNotice",
        component: () =>
          import("@/views/notice/cleanNotice.vue")
      },
      {
        path: "/notice/warNotice",
        component: () =>
          import("@/views/notice/warNotice.vue")
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routerMap.js